import CanvaImport from '@core/lib/admin/components/canva_import'
import PropTypes from 'prop-types'
import React from 'react'

class CanvaImportWrapper extends React.Component {

  static propTypes = {
    onBack: PropTypes.func,
    onNext: PropTypes.func
  }

  _handleDone = this._handleDone.bind(this)

  render() {
    return <CanvaImport { ...this._getCanvaImport()} />
  }
  
  _getCanvaImport() {
    const { onBack } = this.props
    return {
      onBack,
      onDone: this._handleDone
    }
  }

  _handleDone(canva_import) {
    const { assets, design } = canva_import
    this.props.onNext({
      title: design.name,
      type: 'photo',
      canva_template: {
        entity: {
          content: {
            photos: assets.map(asset => ({ 
              photo: {
                asset_id: asset.id,
                asset,
                transforms: {
                  crop: {
                    l: 0,
                    t: 0,
                    w: asset.metadata.width,
                    h: asset.metadata.height
                  }
                }
              } 
            }))
          }
        }
      }
    })
  }

}

export default CanvaImportWrapper

